(function () {
  if (window.__WFY_CART_CONTROLLER__) return;
  window.__WFY_CART_CONTROLLER__ = true;

  const SELECTORS = {
    cartRoot: 'article.form-cart',
    cartForm: 'article.form-cart form[action*="/cart"], article.form-cart form[id^="cart-form-"], article.form-cart form.f8vl',
    checkoutButton: 'article.form-cart button[name="checkout"]',
    pickeasyRoot: '#order-slots, .order-slots',
    termsApp: '.wfy-terms-slot .tnc-checkbox[name="terms"]',
    termsTheme: '.check input[type="checkbox"]'
  };

  const state = {
    termsChecked: false,
    meals: 0,
    min: 5,
    exemptOnly: false,
    requiresShipping: true,
    pickeasyComplete: false,
    guestBypass: false
  };

  let raf = 0;

  function $(sel, root = document) { return root.querySelector(sel); }

  function scheduleRender() {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      render();
    });
  }

  function getCartRoot() {
    return $(SELECTORS.cartRoot);
  }

  function getCartForm() {
    return $(SELECTORS.cartForm);
  }

  function getTermsCheckbox() {
    const cart = getCartRoot();
    if (!cart) return null;
    return cart.querySelector(SELECTORS.termsApp) || cart.querySelector(SELECTORS.termsTheme);
  }

  function readCartData() {
    const cart = getCartRoot();
    if (!cart) return;
    state.meals = parseInt(cart.dataset.meals || 0, 10);
    state.min = parseInt(cart.dataset.min || 5, 10);
    state.exemptOnly = cart.dataset.exemptOnly === 'true';
    state.requiresShipping = cart.dataset.requiresShipping !== 'false';
  }

  function computePickeasyComplete() {
    const pe = $(SELECTORS.pickeasyRoot);
    if (!pe) return false;
    const input = pe.querySelector('datetime-slot-picker .neo-input, .neo-slot-picker .neo-input');
    if (input && typeof input.value === 'string') {
      const v = input.value.trim();
      if (!v) return false;
      if (/choose your delivery date/i.test(v)) return false;
      return true;
    }
    return false;
  }

  function isPickeasyRequired() {
    return state.requiresShipping && !state.exemptOnly;
  }

  function isEligible() {
    const minOk = state.exemptOnly ? true : state.meals >= state.min;
    const termsOk = state.termsChecked === true;
    const pickeasyOk = isPickeasyRequired() ? state.pickeasyComplete === true : true;
    return minOk && termsOk && pickeasyOk;
  }

  // ---- Inline error messages ----
  // Set before=true to insert the message ABOVE the target element
  function showInlineMsg(targetEl, id, text, before) {
    if (!targetEl) return;
    let msg = document.getElementById(id);
    if (!msg) {
      msg = document.createElement('div');
      msg.id = id;
      msg.style.cssText = 'color:#d73509;margin-top:6px;margin-bottom:6px;font-size:1.3rem;font-weight:500;';
      msg.textContent = text;
      if (before) {
        targetEl.parentNode.insertBefore(msg, targetEl);
      } else {
        targetEl.parentNode.insertBefore(msg, targetEl.nextSibling);
      }
    } else {
      msg.textContent = text;
      msg.style.display = '';
    }
  }

  function removeInlineMsg(id) {
    const n = document.getElementById(id);
    if (n) n.style.display = 'none';
  }

  function clearTermsHighlight() {
    const cb = getTermsCheckbox();
    if (cb) {
      const label = cb.closest('.tnc-checkbox-ml') || cb.closest('.wfy-terms-slot');
            if (label) {
        label.style.color = '';
        const a = label.querySelector('a');
        if (a) a.style.color = '#292a56';
      }
    }
  }

  function isLoggedIn() {
    return document.documentElement.getAttribute('data-customer-logged-in') === '1';
  }

    function showLoginPopup() {
    var popup = document.getElementById('wfy-login-popup');
    if (popup) popup.style.display = 'flex';
    // Blur the just-focused input (typically the postcode field) so the mobile
    // keyboard doesn't open and auto-scroll the viewport, which would push the
    // centred popup off-screen on iOS.
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  }

  function hideLoginPopup() {
    var popup = document.getElementById('wfy-login-popup');
    if (popup) popup.style.display = 'none';
  }

  function hasPostcodeEntered() {
    const pe = $(SELECTORS.pickeasyRoot);
    if (!pe) return false;
    const zip = pe.querySelector('#delivery-location-zip, input[name="delivery-location-zip"]');
    return zip && zip.value && zip.value.trim().length > 0;
  }

  function showBlockErrors() {
    const btn = $(SELECTORS.checkoutButton);
    const minOk = state.exemptOnly ? true : state.meals >= state.min;
    const pickeasyOk = isPickeasyRequired() ? state.pickeasyComplete : true;
    const termsSlot = document.querySelector('.wfy-terms-slot');

    // Min meals error — positioned above terms checkbox
    if (state.meals > 0 && !minOk) {
      showInlineMsg(termsSlot || btn, 'min-error', 'Minimum Order is ' + state.min + ' items (excl Gift Vouchers)', true);
    } else {
      removeInlineMsg('min-error');
    }

    // Pickeasy delivery date error — positioned above terms checkbox
    if (!pickeasyOk) {
      if (hasPostcodeEntered()) {
        showInlineMsg(termsSlot || btn, 'pickeasy-error', 'Please select a delivery date & time.', true);
      } else {
        showInlineMsg(termsSlot || btn, 'pickeasy-error', 'Please enter your postcode and select a delivery date.', true);
      }
    } else {
      removeInlineMsg('pickeasy-error');
    }

        // Terms error — highlight the checkbox label in orange
    if (!state.termsChecked) {
      const cb = getTermsCheckbox();
      if (cb) {
        const label = cb.closest('.tnc-checkbox-ml') || cb.closest('.wfy-terms-slot');
                if (label) {
          label.style.color = '#d73509';
          const a = label.querySelector('a');
          if (a) a.style.color = '#d73509';
        }
      }
    } else {
      clearTermsHighlight();
    }
    }

  function updateCheckoutUI() {
    const btn = $(SELECTORS.checkoutButton);
    if (!btn) return;
    var shouldDisable = !isEligible();
    if (btn.disabled !== shouldDisable) {
      btn.disabled = shouldDisable;
    }
    btn.style.pointerEvents = shouldDisable ? 'auto' : '';
  }

  function render() {
    readCartData();
    const cb = getTermsCheckbox();
    state.termsChecked = cb ? !!cb.checked : false;
    state.pickeasyComplete = computePickeasyComplete();
    updateCheckoutUI();
    // Clear individual errors as their conditions are satisfied
        if (state.termsChecked) clearTermsHighlight();
    var termsLink = document.querySelector('.tnc-checkbox-ml a');
    if (termsLink && !termsLink.style.color) termsLink.style.color = '#292a56';
    if (state.pickeasyComplete || !isPickeasyRequired()) removeInlineMsg('pickeasy-error');
    const minOk = state.exemptOnly ? true : state.meals >= state.min;
    if (minOk || state.meals === 0) removeInlineMsg('min-error');
  }

  function recomputeAndRender() {
    readCartData();
    state.pickeasyComplete = computePickeasyComplete();
    const cb = getTermsCheckbox();
    state.termsChecked = cb ? !!cb.checked : false;
    scheduleRender();
  }

  function resetTerms() {
    state.termsChecked = false;
    const cb = getTermsCheckbox();
    if (cb) cb.checked = false;
  }

  function bindEvents() {
    // Terms change (cart scoped)
    document.addEventListener('change', (e) => {
      const cb = getTermsCheckbox();
      if (!cb) return;
      if (e.target !== cb) return;
      state.termsChecked = !!cb.checked;
      scheduleRender();
    }, true);

    // Pickeasy interaction -> re-eval
    document.addEventListener('change', (e) => {
      const pe = $(SELECTORS.pickeasyRoot);
      if (!pe) return;
      if (!pe.contains(e.target)) return;
      scheduleRender();
    }, true);

    // HARD GATE: block form submission unless eligible
    document.addEventListener('submit', (e) => {
      const form = getCartForm();
      if (!form) return;
      if (e.target !== form) return;

      readCartData();
      state.pickeasyComplete = computePickeasyComplete();

      const cb = getTermsCheckbox();
      state.termsChecked = cb ? !!cb.checked : false;

      if (!isEligible()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBlockErrors();
        if (cb && !cb.checked) cb.focus();
        scheduleRender();
      }
    }, true);

    // Cart changes reset terms
    document.addEventListener('wfy:cart-items-changed', () => {
      resetTerms();
      readCartData();
      scheduleRender();
    }, true);

    document.addEventListener('cart:updated', () => {
      enforceTermsRequired();
      readCartData();
      scheduleRender();
    }, true);

    document.addEventListener('wfy:cart-dom-updated', () => {
      setTimeout(() => {
        readCartData();
        scheduleRender();
      }, 0);
    }, true);

    // HARD GATE: block click on checkout button unless eligible
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button[name="checkout"]');
      if (!btn) return;

      const form = getCartForm();
      if (!form || !form.contains(btn)) return;

      readCartData();
      state.pickeasyComplete = computePickeasyComplete();

      const cb = getTermsCheckbox();
      state.termsChecked = cb ? !!cb.checked : false;

      if (!isEligible()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showBlockErrors();
        if (cb && !cb.checked) cb.focus();
        scheduleRender();
      }
    }, true);

    // Login popup: button handlers
    document.addEventListener('click', (e) => {
      if (e.target.id === 'wfy-guest-checkout') {
        state.guestBypass = true;
        hideLoginPopup();
      }
      if (e.target.id === 'wfy-login-close' || e.target.classList.contains('wfy-login-backdrop')) {
        hideLoginPopup();
      }
    });

    // Show login popup when non-logged-in customer interacts with Pickeasy
    // (triggers on the postcode input — the first step of the delivery flow)
    document.addEventListener('focusin', (e) => {
      if (isLoggedIn() || state.guestBypass) return;
      const pe = $(SELECTORS.pickeasyRoot);
      if (!pe || !pe.contains(e.target)) return;
      var isInput = e.target.matches('input, select, textarea, .neo-input');
      if (isInput) {
        showLoginPopup();
      }
    });

    // Show errors when user taps/clicks the DISABLED checkout button.
    // (click events don't fire on disabled buttons, but pointerdown does)
    document.addEventListener('pointerdown', (e) => {
      const btn = e.target.closest('button[name="checkout"]');
      if (!btn || !btn.disabled) return;

      const form = getCartForm();
      if (!form || !form.contains(btn)) return;

      readCartData();
      state.pickeasyComplete = computePickeasyComplete();
      const cb = getTermsCheckbox();
      state.termsChecked = cb ? !!cb.checked : false;

      if (!isEligible()) {
        showBlockErrors();
      }
    }, true);
  }

  function watchPickeasyValuePolling() {
    let last = null;

    function tick() {
      const pe = $(SELECTORS.pickeasyRoot);
      if (!pe) return;

      const input = pe.querySelector('datetime-slot-picker .neo-input, .neo-slot-picker .neo-input');
      if (!input) return;

      const v = (input.value || '').trim();
      if (v !== last) {
        last = v;
        scheduleRender();
      }
    }

    setInterval(tick, 300);
  }

  function enforceTermsRequired() {
    const cb = getTermsCheckbox();
    if (!cb) return;
    cb.required = true;
    cb.setAttribute('aria-required', 'true');
  }

  function init() {
    readCartData();
    const cb = getTermsCheckbox();
    state.termsChecked = cb ? !!cb.checked : false;
    enforceTermsRequired();
    bindEvents();
    watchPickeasyValuePolling();
    scheduleRender();
  }

  init();
})();
